import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';

function HairLineDivider() {
  return <View style={styles.viewContainer} testID="hairLineDivider" />;
}

const styles = StyleSheet.create({
  viewContainer: {
    backgroundColor: theme.color.border.primarySolid,
    height: 1,
  },
});

export default HairLineDivider;
